import { Practice } from "../Practice/schema"
import { PartialPractice } from "./schema"

export const hasConditionalReqs = (
  practice?: Practice | PartialPractice | null,
): boolean => {
  if (!practice) return false

  const hasMultipleLocations = practice?.locations.length > 1
  const doesProvideGroupLiabilityInsurance = !!practice?.authReleaseRequired
  return hasMultipleLocations || !doesProvideGroupLiabilityInsurance
}
